function pad2(n: number) {
  return String(n).padStart(2, '0')
}

/** YYYY-MM-DD */
function isoDate(d: Date): string {
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`
}

/** Быстрые интервалы дат как в classic DebugAI. */
export function debugDatePreset(
  preset: 'yesterday' | 'last7' | 'last_week' | 'thu_fri',
): { from: string; to: string } {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  if (preset === 'yesterday') {
    const d = new Date(today)
    d.setDate(d.getDate() - 1)
    const s = isoDate(d)
    return { from: s, to: s }
  }
  if (preset === 'last7') {
    const to = new Date(today)
    to.setDate(to.getDate() - 1)
    const from = new Date(to)
    from.setDate(from.getDate() - 6)
    return { from: isoDate(from), to: isoDate(to) }
  }
  if (preset === 'last_week') {
    const dow = today.getDay()
    const mondayOffset = dow === 0 ? -6 : 1 - dow
    const lastMon = new Date(today)
    lastMon.setDate(today.getDate() + mondayOffset - 7)
    const lastSun = new Date(lastMon)
    lastSun.setDate(lastMon.getDate() + 6)
    return { from: isoDate(lastMon), to: isoDate(lastSun) }
  }
  if (preset === 'thu_fri') {
    const dow = today.getDay()
    let daysToLastThu = (dow - 4 + 7) % 7
    if (daysToLastThu === 0) daysToLastThu = 7
    const lastThu = new Date(today)
    lastThu.setDate(today.getDate() - daysToLastThu)
    const lastFri = new Date(lastThu)
    lastFri.setDate(lastThu.getDate() + 1)
    return { from: isoDate(lastThu), to: isoDate(lastFri) }
  }
  return { from: '', to: '' }
}
